import React from 'react';
import {
  mdiRunFast, mdiBikeFast, mdiSwim, mdiWall, mdiWeightLifter,
  mdiFlagCheckered, mdiSofaSingle, mdiBike, mdiDumbbell,
  mdiTimerOutline, mdiSkiCrossCountry, mdiRowing, mdiDotsHorizontal,
  mdiWalk, mdiHiking, mdiYoga, mdiSoccer, mdiBasketball, mdiTennis,
} from '@mdi/js';
import {resolveSportIconName} from '../utils/sportIcons';

const SPORT_PATHS: Record<string, string> = {
  'run-fast': mdiRunFast, 'bike-fast': mdiBikeFast, swim: mdiSwim, wall: mdiWall,
  'weight-lifter': mdiWeightLifter, 'flag-checkered': mdiFlagCheckered,
  'sofa-single': mdiSofaSingle, bike: mdiBike, dumbbell: mdiDumbbell,
  'timer-outline': mdiTimerOutline, 'ski-cross-country': mdiSkiCrossCountry,
  rowing: mdiRowing, 'dots-horizontal': mdiDotsHorizontal, walk: mdiWalk,
  hiking: mdiHiking, yoga: mdiYoga, soccer: mdiSoccer, basketball: mdiBasketball, tennis: mdiTennis,
};

type WorkoutTypeIconProps = {
  typeId?: number | null;
  name?: string | null;
  size?: number;
  className?: string;
};

/** Exact Material Design Icons silhouettes, matching the Android sport glyphs. */
export function WorkoutTypeIcon({typeId, name, size = 18, className}: WorkoutTypeIconProps) {
  const icon = resolveSportIconName(typeId, name);
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"
    className={className} aria-hidden="true" focusable="false" data-sport-icon={icon}
    style={{display: 'inline-block', flexShrink: 0, verticalAlign: 'middle'}}>
    <path d={SPORT_PATHS[icon] ?? mdiDotsHorizontal} />
  </svg>;
}
